<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8">
        <h2>Coaching Summary</h2>
        <v-row>
          <!-- <v-col cols="4">
            <v-select
              v-model="cohort"
              label="Cohort"
              :items="['CONSUMER', 'CORPORATE']"
              outlined
              dense
              hide-details
              :clearable="true"
            ></v-select>
          </v-col> -->
          <!-- metric date causing all sorts of bugs. Default to today and be done with it. -->
          <!-- <v-col cols="4">
            <v-menu
              ref="menu1"
              v-model="menu1"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="metricDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Metric Date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="metricDate"></v-date-picker>
            </v-menu>
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12">
        <coach-engagement team="Coaching" :metricDate="metricDate" :cohort="cohort" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CoachEngagement from "@/components/reporting/blocks/CoachEngagement";

export default {
  name: "EngagementSummaryCoaching",
  components: {
    CoachEngagement,
  },
  data() {
    return {
      menu1: null,
      metricDate: this.$moment().format("YYYY-MM-DD"),
      cohort: null,
    };
  },
  created() {
    if (this.$store.getters.isContractor) {
      this.$router.push({ name: "CoachingOneOnOneSubscription", params: { coachId: this.$store.getters.user.id } });
    }
  },
};
</script>
